import { render, staticRenderFns } from "./Ezam.vue?vue&type=template&id=dfbe3a06&scoped=true"
import script from "./Ezam.vue?vue&type=script&lang=js"
export * from "./Ezam.vue?vue&type=script&lang=js"
import style0 from "./Ezam.vue?vue&type=style&index=0&id=dfbe3a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbe3a06",
  null
  
)

export default component.exports